import * as yup from 'yup';

import { ObjectTypeBase } from '../../types/baseTypes/ObjectTypeBase';
import { PropertiesInterface } from '../../types/properties/Property';
import { TypeContextEnum } from '../../types/properties/TypeContextEnum';
import Types from '../Types';
import { TYPE_GROUP_LANE } from '../constants';
import createShapeFromProperties from '../createShapeFromProperties';

const properties: PropertiesInterface = {
  _id: {
    type: 'UUID',
    validators: [
      {
        name: 'Required',
        value: true,
      },
    ],
  },
};

/**
 * @deprecated This class is deprecated and should not be used in new code.
 * Use UserType from application-types instead.
 */
export class UserType extends ObjectTypeBase {
  group = TYPE_GROUP_LANE;

  name = 'User';

  friendlyName = 'User';

  contexts = [TypeContextEnum.Block, TypeContextEnum.Content];

  get example() {
    return {
      _id: '000000yy1oifVoJgbY8nGc',
    };
  }

  get default(): any {
    return {
      _id: null,
    };
  }

  buildSchema() {
    return yup
      .object()
      .nullable()
      .default(null)
      .shape(createShapeFromProperties(properties));
  }

  properties = properties;
}

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use User from application-types instead.
 */
const definition = new UserType();

Types.addBaseType(definition);
export default definition;
